/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, DropdownSelectField, InputNumberField, Icon } from '@jutro/legacy/components';
import { ServiceManager } from '@jutro/legacy/services';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { PremierConstants } from 'premier-constant-service';
import { Link } from '@jutro/router';
import styles from './RevenueBusinessActivitiesComponent.module.scss';
import metadata from './RevenueBusinessActivitiesComponent.metadata.json5';
import { TranslatorContext } from '@jutro/legacy/locale';

function RevenueBusinessActivitiesComponent(props) {

    const {
        data: RevenueBusinessActivitiesVM,
        updateWizardData,
        submissionVM,
        RevenueBusinessActivitiesPath
    } = props;
    const localeService = ServiceManager.getService('locale-service');
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useContext(TranslatorContext);
    const { authHeader } = useAuthentication();
    const { lineName } = PremierConstants;
    const productCode = _.get(submissionVM.value, 'baseData.productCode');
    // eslint-disable-next-line security/detect-object-injection
    const lobLineName = productCode ? lineName[productCode] : '';

    const addRevenueBusinessActivities = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            RevenueBusinessActivitiesVM.value = RevenueBusinessActivitiesVM.value || []

            const { _xCenter, _dtoName } = RevenueBusinessActivitiesVM;

            const SubsidiaryInformationObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            RevenueBusinessActivitiesVM.pushElement(
                SubsidiaryInformationObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, RevenueBusinessActivitiesVM, viewModelService]
    );


    const handleValueChange = useCallback(
        (val, changedPath, index) => {
            if (changedPath === 'perOfRev3') {
                let feeFroAllOfAppOpeLas = 0;

                if(!_.isUndefined(_.get(submissionVM.value, 'lobData.proLine.coverables.medicalParctitionarsCoverable.revenue.feeFroAllOfAppOpeLas2'))) {
                    feeFroAllOfAppOpeLas = (val/100) * _.get(submissionVM.value, 'lobData.proLine.coverables.medicalParctitionarsCoverable.revenue.feeFroAllOfAppOpeLas2.amount')
                }

                const revenueObj = {
                    amount: feeFroAllOfAppOpeLas,
                    currency: localeService.getDefaultCurrencyCode()
                }

                _.set(RevenueBusinessActivitiesVM.value[index], 'rev4', revenueObj)  
            }            

            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    const retrieveClassType = useCallback(
        async (val, changedPath, index) => {
            const selectedOffValue = _.get(submissionVM.value, `lobData.${lobLineName}.selectedOffering_Ext`);
            const displayName = translator({
                id: `typekey.EY_Ser2.${val}`,
                defaultMessage: val
            });
            const response = await LoadSaveService.retrieveClassType_Ext(selectedOffValue, displayName, authHeader);

            // eslint-disable-next-line security/detect-object-injection
            _.set(RevenueBusinessActivitiesVM.value[index], 'claTyp2', response);
            handleValueChange(val, changedPath, index);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [handleValueChange]
    );

    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            RevenueBusinessActivitiesVM.value.splice(index, 1);
            _.set(submissionVM.value, RevenueBusinessActivitiesPath, RevenueBusinessActivitiesVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, RevenueBusinessActivitiesPath, RevenueBusinessActivitiesVM.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'ser2') {
                const value = (item && item.ser2) ? item.ser2 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = RevenueBusinessActivitiesVM.length > 0 && RevenueBusinessActivitiesVM.children[index].ser2
                    // eslint-disable-next-line security/detect-object-injection
                    ? RevenueBusinessActivitiesVM.children[index].ser2.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.ser2 = val;
                            retrieveClassType(val, changedPath, index)
                            // handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                )
            }

            if (path === 'claTyp2') {
                const value = (item && item.claTyp2) ? item.claTyp2 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = RevenueBusinessActivitiesVM.length > 0 && RevenueBusinessActivitiesVM.children[index].claTyp2
                    // eslint-disable-next-line security/detect-object-injection
                    ? RevenueBusinessActivitiesVM.children[index].claTyp2.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.claTyp2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                )
            }

            if (path === 'perOfRev3') {
                const value = item.perOfRev3 ? item.perOfRev3 : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.perOfRev3 = val;
                            handleValueChange(val, changedPath, index)
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'rev4') {
                const value = item.rev4 ? item.rev4 : '';

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        value={value}
                        readOnly
                    />
                );
            }

            if (path === 'des5') {
                const value = item.des5 ? item.des5 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.des5 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }


        }, [handleValueChange, RevenueBusinessActivitiesVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`RevenueBusinessActivitiesTable`]: {
            data: RevenueBusinessActivitiesVM.value,
        }

    }), [RevenueBusinessActivitiesVM.value])

    const resolvers = {
        resolveCallbackMap: {
            addRevenueBusinessActivities,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            RevenueBusinessActivitiesVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [RevenueBusinessActivitiesVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={RevenueBusinessActivitiesVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

RevenueBusinessActivitiesComponent.propTypes = wizardProps;
export default withRouter(RevenueBusinessActivitiesComponent);
